import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { serviceQueryKey } from '../queryKeys'

import { useQuery } from '@percent/utility'
import { useServices } from '@percent/admin-dashboard/containers/service/ServiceContext'
import { ErrorView, Loader } from '@percent/admin-dashboard/common/components'
import { useRequiredParams } from '@percent/admin-dashboard/common/hooks'
import { useBreadcrumbsData } from '@percent/admin-dashboard/app/Layout/breadcrumbsContext/useBreadcrumbsData/useBreadcrumbsData'
import { ServiceDetail } from './ServiceDetail'

export function ServiceDetailContainer() {
  const { t } = useTranslation()
  const { serviceId } = useRequiredParams<{ serviceId: string }>()
  const { setPath } = useBreadcrumbsData()
  const { internalServiceService } = useServices()

  const { data, isLoading, errorMessage, refetch } = useQuery(
    serviceQueryKey(serviceId),
    internalServiceService.getServiceById,
    { id: serviceId }
  )

  const serviceName = data?.name

  useEffect(() => {
    setPath(serviceName)

    return () => setPath(undefined)
  }, [serviceName, setPath])

  if (isLoading) {
    return <Loader />
  }

  if (!data) {
    return (
      <div data-testid="service-not-available">
        <ErrorView errorMessage={errorMessage || t('serviceDetail.notAvailable')} />
      </div>
    )
  }

  return <ServiceDetail service={data} onChanged={refetch} />
}
